import * as yup from 'yup';
import tlds from 'tlds';

export enum SIGNUP_TYPES {
  PRIVATE = 'private',
  COMPANY = 'company',
  CO_USER = 'CO_USER',
  BIKE = 'BIKE',
  ORG = 'ORG',
  PARTNER = 'PARTNER',
  ALTERNATIVE = 'ALTERNATIVE',
  FREELANCER = 'FREELANCER',
  solopreneur = 'solopreneur',
}

export enum LEGAL_TYPES {
  AG = 'AG',
  EV = 'e.V.',
  GmbH = 'GmbH',
  CoKG = 'GmbH & Co KG',
  gGmbH = 'gGmbH',
  KG = 'KG',
  OHG = 'OHG',
  Sonstige = 'Sonstige',
}

export const SignupModal = (signupType) => ({
  ...(signupType === SIGNUP_TYPES.ORG && {
    companyName: '',
    legalType: '',
    otherLegalType: '',
    registerNr: '',
    registerLocation: '',
  }),
  ...(signupType === SIGNUP_TYPES.FREELANCER && {
    companyName: '',
  }),
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  signupType: SIGNUP_TYPES.PRIVATE,
});

export const SignupSchema = (
  signupType: string,
  localize: any,
  passwordRegex: string
): any =>
  yup.object({
    ...(signupType === SIGNUP_TYPES.ORG && {
      companyName: yup.string().required(localize('validation.required')),
      legalType: yup.string().required(localize('validation.required')),
      otherLegalType: yup.string(),
      registerNr: yup.string().when('legalType', {
        is: (legalType) => legalType !== LEGAL_TYPES.Sonstige,
        then: () => yup.string().required(localize('validation.required')),
        otherwise: () => yup.string(),
      }),
      registerLocation: yup.string().when('legalType', {
        is: (legalType) => legalType !== LEGAL_TYPES.Sonstige,
        then: () => yup.string().required(localize('validation.required')),
        otherwise: () => yup.string(),
      }),
    }),
    ...(signupType === SIGNUP_TYPES.FREELANCER && {
      companyName: yup.string(),
    }),
    firstName: yup
      .string()
      .required(localize('validation.required'))
      .matches(
        /[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüŸ¡¿çÇŒœßØøÅåÆæÞþÐðşa-zA-Z-.]+/,
        localize('input.error.invalid')
      ),
    lastName: yup
      .string()
      .required(localize('validation.required'))
      .matches(
        /[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüŸ¡¿çÇŒœßØøÅåÆæÞþÐðşa-zA-Z-.]+/,
        localize('input.error.invalid')
      ),
    email: yup
      .string()
      .required(localize('validation.required'))
      .matches(/^[\w-.+]+@([\w-]+\.)+[\w-]+$/, localize('input.error.invalid'))
      .test('is-valid-tld', localize('input.error.invalid'), (value) => {
        const domain = value?.split('@')[1];
        if (!domain) return false;
        const tld = domain?.split('.').pop().toLowerCase();
        return tlds.includes(tld);
      }),
    password: yup
      .string()
      .required(localize('validation.required'))
      // @ts-ignore
      .matches(passwordRegex, localize('input.password.error.invalid')),
  });
